/**
 * Route for `click-level-detail-reports`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ClickLevelDetailReportsPage } from "../features/click-level-detail-reports/ClickLevelDetailReportsPage";

export const clickLevelDetailReportsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/click-level-detail-reports",
	component: ClickLevelDetailReportsPage,
});

export default clickLevelDetailReportsRoute;
